import { pageRoutes } from "../../../../routes";

export const getEditTileUrl = (clientCode: string, dashboardId: string, tileId: string) => {
  return `/${clientCode}/${pageRoutes.dashboards}/${dashboardId}/edit/widgets/${tileId}/edit`;
};

export const getDashboardViewUrl = (clientCode: string, dashboardId: string) => {
  return `/${clientCode}/${pageRoutes.dashboards}/${dashboardId}/view`;
};
